module.exports = __webpack_public_path__ + "static/media/bg-feature-circle.a3264dff.svg";